<style >
   .col-xl, .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg, .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md, .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm, .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col, .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1{padding-top: 0; padding-bottom: 0;}
   .v-input--selection-controls{margin-top: 0px;}
   .v-messages{min-height: 0;}
   .theme--light.v-chip:not(.v-chip--active){background: #01579b;color: white;}
   .headline{       
        color: #ffffff;font-weight: 500;
    }
    .v-data-table__wrapper table tbody td {
        font-size: 0.8rem;
    }
    .v-card__title.headline{
        color: #c31818;
    }
   /* .text-start{
        display: flex;
    }*/
</style>
<template >
  <v-layout id="pros">  
      <v-flex>                    
        <v-data-table
        :headers="headersp"
        :items="filteredDesserts"        
        :search="search"
        :pagination.sync="pagination"
        item-key="name"
        class="elevation-1"
        :loading="loadigtable"
        loading-text="Loading... Please wait"
        :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'skip_previous',
            lastIcon: 'skip_next',
            prevIcon: 'keyboard_arrow_left',
            nextIcon: 'keyboard_arrow_right'
        }"
        >
        <template slot="headers" slot-scope="props">
        <tr>
          <th
            v-for="headere in props.headersp"
            :key="headere.text"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', headere.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(headere.value)"
          >
            <v-icon small>arrow_upward</v-icon>
            {{ headere.text }}
          </th>
        </tr>
        <tr class="grey lighten-3">
          <th>
            <v-icon>filter_list</v-icon>
          </th>
          <th
            v-for="headere in props.headersp"
            :key="headere.text"
          >
            <div v-if="filters.hasOwnProperty(headere.value)">
              <v-select flat hide-details small multiple clearable :items="columnValueList(headere.value)" v-model="filters[headere.value]">
              </v-select>
            </div>
          </th>
        </tr>
        </template>
        <template slot="item" slot-scope="prospectos" >
            <tr>
                <td style="display:flex;">
                    <v-tooltip top v-if="$store.state.usuario.rol === 'Telemarketing' && prospectos.item.telemarketing === true && prospectos.item.nusuarioactivo == false">
                    <template v-slot:activator="{ on, attrs }">                    
                        <v-icon
                        v-bind="attrs"
                        v-on="on"
                            small
                            class="mr-2"
                            @click="editItemP(prospectos.item)"
                            style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                            color="#3d5170"
                            >
                            edit
                        </v-icon>
                    </template>
                    <span>Edit</span>
                    </v-tooltip>
                    <v-tooltip v-if="$store.state.usuario.rol !== 'Telemarketing'" >
                        <template v-slot:activator="{ on, attrs }">                    
                            <v-icon
                            v-bind="attrs"
                            v-on="on"
                                small
                                class="mr-2"
                                @click="editItemP(prospectos.item)"
                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                color="#3d5170"
                                >
                                edit
                            </v-icon>
                        </template>
                        <span>Edit</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">                    
                            <v-icon
                            v-bind="attrs"
                            v-on="on"
                                small
                                class="mr-2"
                                @click="showEvent(prospectos.item)"
                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                color="#3d5170"
                                >
                                assignment
                            </v-icon>
                        </template>
                        <span>Report</span>
                    </v-tooltip>
                    <template v-if="prospectos.item.activo">
                        <v-tooltip top v-if="$store.state.usuario.rol === 'Administrador'">
                            <template v-slot:activator="{ on, attrs }">                    
                                <v-icon
                                v-bind="attrs"
                                v-on="on"
                                small
                                @click="activarDesactivarMostrar(2,prospectos.item)"     
                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                color="#3d5170"         
                                >
                                block
                                </v-icon> 
                            </template>
                            <span>Desactivar</span>
                        </v-tooltip>
                    </template>
                    <template v-else>
                        <v-tooltip top v-if="$store.state.usuario.rol === 'Administrador'">
                            <template v-slot:activator="{ on, attrs }">                    
                                <v-icon
                                v-bind="attrs"
                                v-on="on"
                                small 
                                @click="activarDesactivarMostrar(1,prospectos.item)"                   
                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                color="#3d5170"
                                >
                                check
                                </v-icon>
                            </template>
                            <span>Activar</span>
                        </v-tooltip>
                    </template> 
                </td>
                <td style="padding: 0 3px 0 10px;">{{prospectos.item.nombre}}</td>
                <td style="padding: 0 5px 0 10px;">{{prospectos.item.nombrepais}}</td>
                <td style="padding: 0 5px 0 10px;">{{prospectos.item.producto}}</td>
                <td style="padding: 0 5px 0 10px;">{{prospectos.item.potencialV}}</td>
                <td style="padding: 0 5px 0 10px;">{{prospectos.item.observaciones}}</td>
                <td style="text-align:center;">
                    <template v-if="prospectos.item.asignacion">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }"  v-if="rolejecutivo === 'Telemarketing' || rolejecutivo === 'Administrador' || rolejecutivo === 'Marketing' || rolejecutivo === 'ComercialAdmin' || (rolejecutivo === 'Telemarketing' & prospectos.item.nusuarioactivo === false)">
                                <v-icon
                                v-bind="attrs"
                                v-on="on"
                                small
                                class="green--text mr-2"
                                @click="asignarpros(1,prospectos.item)"
                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                >
                                    done
                                </v-icon>
                            </template>
                            <span>Desasignar</span>
                        </v-tooltip>
                    </template>
                    <template v-else>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }" v-if="rolejecutivo === 'Telemarketing' || rolejecutivo === 'Administrador' || rolejecutivo === 'Marketing' || rolejecutivo === 'ComercialAdmin'">
                                <v-icon
                                v-bind="attrs"
                                v-on="on"
                                    small
                                    class="red--text mr-2"
                                    style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                    @click="asignarpros(2,prospectos.item)"
                                    >
                                        clear
                                    </v-icon>
                            </template>
                            <span>Asignar</span>
                        </v-tooltip>
                    </template>
                </td>
                <td style="padding: 0 5px 0 10px;">{{prospectos.item.nusuario}} aqui</td>
                <td style="padding: 0 5px 0 10px;">
                    <div v-if="prospectos.item.activo">
                        <span class="blue--text">Activo</span>                
                    </div>
                    <div v-else>
                        <span class="red--text">Inactivo</span>                
                    </div> 
                </td>
            </tr>
        </template>
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>Prospectos</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-select v-if="viewadmin == true" style="width: 100px;margin-top: 20px;" v-model="buscarpor" v-on:change="Mostrarusuarios()" dense outlined :items="buscar" ></v-select>
                <v-select style="width: 100px;margin-top: 20px;margin-left:8px;" v-on:change="buscarporI()" v-model="ejecutivo" v-if="mostrarej==true" dense outlined :items="usuarios"></v-select>
                <v-text-field style="margin-left:8px;" class="text-xs-center" v-if="mostrartext==true" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <!--<v-btn style="margin-left:8px;" color="primary" @click="">Buscar</v-btn>   -->             
                <v-spacer></v-spacer>  
                <v-row justify="center">
                    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                        <v-card><!--Informacion de Prospectos-->
                            <v-toolbar dark color="light-blue darken-3">
                            <v-btn  icon dark @click="dialog=false">
                                <v-icon>close</v-icon>
                            </v-btn>
                            <v-toolbar-title class="titulo"><span class="headline">{{ formTitle }}</span></v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-btn dark text @click="guardar">Guardar</v-btn>
                            </v-toolbar-items>
                            </v-toolbar>
                            <v-form style="background: #f5f5f5;">
                                <v-container>                                    
                                    <v-row style="padding-bottom:16px;">
                                        <v-col>
                                            <v-card class="mx-auto">
                                                <v-card-text>
                                                    <v-row style="padding: 0px 16px;">
                                                        <v-col>
                                                            <v-row style="align-items: center"><!--Nombre-Pais-Estado-Estatus-->
                                                                <v-col cols="11" sm="11" lg="11" xl="11" style="display: flex;align-items: center;" >
                                                                    <v-text-field v-model="editprospecto.nombre" append-icon="search" label="*Nombre prospecto"></v-text-field>
                                                                    <v-btn color="primary" style="margin-left:16px;" @click="addRazon=true"><v-icon>group_add</v-icon></v-btn>
                                                                </v-col>
                                                                <v-col cols="1" sm="1" md="1" lg="1" xl="1">
                                                                    <div style="width: 100%;display: flex;">
                                                                        <span style="width: 100%;text-align: center;color: #0277bd;font-weight: 500;" v-if="editprospecto.cliente == true">{{clienteprospectot}}</span>
                                                                        <span style="width: 100%;text-align: center;color: #f44336;font-weight: 500;" v-else>{{clienteprospecto}}</span>
                                                                    </div>
                                                                    <v-switch
                                                                    v-model="editprospecto.cliente"
                                                                    size="24"
                                                                    class="ml-2"
                                                                    ></v-switch>
                                                                </v-col>
                                                                <v-col cols="12" sm="4" md="3">
                                                                    <v-select v-model="editprospecto.idpais" v-on:change="activarestado" :items="paises" label="*País">
                                                                    </v-select>
                                                                </v-col>
                                                                <v-col cols="12" sm="4" md="3">
                                                                    <v-select v-model="editprospecto.idestado" :items="estados" label="*Estado" >
                                                                    </v-select>
                                                                </v-col>
                                                                <v-col>
                                                                    <v-select v-model="editprospecto.idestatus" :items="estatus" label="Estatus">
                                                                    </v-select>
                                                                </v-col>
                                                                <v-col>
                                                                    <v-select v-model="editprospecto.tio_cuenta" :items="tcuentas"  label="Tipo de cuenta">                                                                    
                                                                    </v-select>                                            
                                                                </v-col>
                                                            </v-row>
                                                            <v-row><!--Direccion-Producto-PotencialV-Industria-->
                                                                <v-col cols="12" sm="6" md="4">
                                                                    <v-textarea prepend-icon="mdi-comment" outlined   v-model="editprospecto.direccion" label="*Dirección"></v-textarea>
                                                                </v-col>
                                                                <v-col>
                                                                    <v-textarea outlined   v-model="editprospecto.observaciones" label="Observaciones"></v-textarea>
                                                                </v-col>
                                                                <v-col cols="12" sm="12" md="4">
                                                                    <v-row>
                                                                        <v-col cols="12" md="12" lg="12">
                                                                            <v-text-field v-model="editprospecto.producto" style="padding-top: 0px; margin-top: 0px;" label="Producto"></v-text-field>
                                                                        </v-col>                                                
                                                                    </v-row>
                                                                    <v-row>
                                                                        <v-col cols="12" md="12" lg="12">
                                                                            <v-text-field v-model="editprospecto.potencialV" style="padding-top: 0px; margin-top: 0px;" label="Potenial de volumen"></v-text-field>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-col>                                   
                                                            </v-row>
                                                            <v-row>
                                                                <v-col cols="12" md="12" lg="12">
                                                                    <!--<v-text-field v-model="editprospecto.industria" style="padding-top: 0px; margin-top: 0px;" label="Industria"></v-text-field>-->
                                                                    <v-combobox v-model="industriaselect" :items="nindustria" label="*Industria" multiple outlined dense></v-combobox>
                                                                </v-col>  
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>                                                    
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                    <v-spacer></v-spacer>
                                    <v-row justify="space-around"><!--Tipo de Operacion-..-->
                                        <v-col md="6">
                                            <v-card class="mx-auto" style="height: 256px;">
                                                 <v-list-item two-line>
                                                    <v-list-item-content style="padding-bottom: 0;">                                                         
                                                        <v-toolbar flat color="white">
                                                            <v-row>
                                                                <v-col>
                                                                    <v-toolbar-title>Tipo de operación</v-toolbar-title>
                                                                </v-col>
                                                                <v-col style="display: contents;">
                                                                    <v-btn v-model="BtnCheck" @click="checkall=true,allcheck()" style="background-color: transparent;">
                                                                        <v-checkbox v-model="checkall"  hide-details></v-checkbox>
                                                                        <span>ALL</span>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-toolbar>
                                                        <v-divider
                                                            class="mx-4"
                                                            inset                                                            
                                                            ></v-divider>                                                                                                                                                                            
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-card-text style="padding-top: 0;">
                                                    <v-row style="padding: 1px 10px;">                                                 
                                                        <v-col>
                                                            <v-checkbox v-model="editprospecto.impo" label="Impo"></v-checkbox>
                                                        </v-col>
                                                        <v-col>
                                                            <v-checkbox v-model="editprospecto.expo"   label="Expo"></v-checkbox>
                                                        </v-col>
                                                        <v-col>
                                                            <v-checkbox v-model="editprospecto.fcl" label="FCL"></v-checkbox>
                                                        </v-col>
                                                        <v-col>
                                                            <v-checkbox v-model="editprospecto.lcl" label="LCL"></v-checkbox>
                                                        </v-col>
                                                        <v-col>
                                                            <v-checkbox v-model="editprospecto.ftl" label="FTL"></v-checkbox>
                                                        </v-col>
                                                        <v-col>
                                                            <v-checkbox v-model="editprospecto.ltl" label="LTL"></v-checkbox>
                                                        </v-col>
                                                        <v-col>
                                                            <v-checkbox v-model="editprospecto.intermodal" label="Intermodal"></v-checkbox>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>                                                                                                  
                                        </v-col>
                                        <v-col>
                                            <v-card class="mx-auto" style="height: 256px;">
                                            <v-row>
                                                <v-col>                                                    
                                                    <v-list-item two-line>
                                                        <v-list-item-content style="padding-bottom: 0;">                                                        
                                                            <v-toolbar flat color="white">
                                                                <v-row>
                                                                    <v-col>
                                                                        <v-toolbar-title>Modalidad de transporte</v-toolbar-title>
                                                                    </v-col>
                                                                    <v-col style="display: contents;">
                                                                        <v-btn v-model="BtnCheck2" @click="checkall2=true,allcheck2()" style="background-color: transparent;">
                                                                            <v-checkbox v-model="checkall2"  hide-details></v-checkbox>
                                                                            <span>ALL</span>
                                                                        </v-btn>
                                                                    </v-col>
                                                                </v-row>                                                             
                                                            </v-toolbar>
                                                            <v-divider class="mx-4" inset ></v-divider>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                    <v-card-text style="padding-bottom: 0; padding-top: 0;">  
                                                        <v-row>
                                                            <v-col>
                                                                <v-checkbox v-model="editprospecto.maritimo" label="Marítimo"></v-checkbox>
                                                            </v-col>
                                                            <v-col>
                                                                <v-checkbox v-model="editprospecto.aereo" label="Aéreo"></v-checkbox>
                                                            </v-col>
                                                            <v-col>
                                                                <v-checkbox v-model="editprospecto.terrestre" label="Terrestre"></v-checkbox>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-textarea
                                                    outlined                                                    
                                                    v-model="editprospecto.zona"
                                                    label="Zona"
                                                    style="padding: 0 16px;"                                                    
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>                                      
                                            </v-card>                                                                                        
                                        </v-col>                                       
                                    </v-row>                                    
                                 <!--   <v-row><--Origen - Destino
                                         <v-col>                                             
                                            <p class="title">Origenes</p>                                            
                                            <v-combobox
                                                     v-model="origenes"
                                                :items="paises"
                                                :search-input.sync="searcho"
                                                hide-selected                                               
                                                label="Origenes"
                                                multiple
                                                persistent-hint
                                                small-chips   
                                                >
                                                    <template v-slot:selection="{ attrs, item, select, selected }">
                                                        <v-chip
                                                            v-bind="attrs"
                                                            class="ma-2"
                                                            color="light-blue darken-4"
                                                            text-color="white"
                                                            :input-value="selected"
                                                            close
                                                            @click="select"
                                                            @click:close="removeorigenes(item)"
                                                        >
                                                            <strong>{{ item.text }}</strong>&nbsp;                                                            
                                                        </v-chip>
                                                    </template>
                                                </v-combobox>
                                        </v-col>
                                        <v-col>
                                            <p class="title">Destinos</p> 
                                            <v-combobox
                                                v-model="destinos"
                                                :items="paises"
                                                chips
                                                clearable
                                                label="Destinos"
                                                multiple                                                        
                                                solo
                                            >
                                                <template v-slot:selection="{ attrs, item, select, selected }">
                                                    <v-chip
                                                        v-bind="attrs"
                                                        :input-value="selected"
                                                        color="light-blue darken-4"
                                                        text-color="white"
                                                        close
                                                        @click="select"
                                                        @click:close="removedestinos(item)"
                                                    >
                                                        <strong>{{ item.text }}</strong>&nbsp;
                                                        
                                                    </v-chip>
                                                </template>
                                            </v-combobox>
                                        </v-col>
                                    </v-row>-->
                                    <v-row style="padding:16px;">
                                        <v-col> <!-- Origen -->
                                            <v-combobox
                                                v-model="origenes"
                                                :items="paises"
                                                :search-input.sync="searcho"
                                                hide-selected                                               
                                                label="*Orígenes"
                                                multiple
                                                persistent-hint
                                                small-chips                                                
                                                >
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                        No hay resultados que coincidan "<strong>{{ searcho }}</strong>". presiona <kbd>enter</kbd> para crear uno nuevo
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-combobox>
                                        </v-col>
                                        <v-col> <!-- Destino -->
                                            <v-combobox
                                                v-model="destinos"
                                                :items="paises"
                                                :search-input.sync="searchp"
                                                hide-selected                                               
                                                label="*Destinos"
                                                multiple
                                                persistent-hint
                                                small-chips                                                
                                                >
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                        No hay resultados que coincidan "<strong>{{ searchp }}</strong>". presiona <kbd>enter</kbd> para crear uno nuevo
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-combobox>
                                        </v-col>
                                    </v-row>
                                     <v-row><!--Contactos-->
                                        <v-col cols="12">
                                            <v-card class="mx-auto">
                                                 <v-list-item two-line>
                                                    <v-list-item-content>                                                        
                                                        <v-toolbar flat color="white">
                                                            <v-toolbar-title>Contactos</v-toolbar-title>
                                                            <v-divider
                                                            class="mx-4"
                                                            inset
                                                            vertical
                                                            ></v-divider>
                                                            <v-spacer></v-spacer>
                                                            <v-col cols="2" sm="2" md="2" lg="2" xl="2">
                                                                <div style="width: 100%;">
                                                                    <span style="width: 100%;text-align: center;color: #0277bd;font-weight: 500;" v-if="editprospecto.contacto == true">Pendiente</span>
                                                                    <span style="width: 100%;text-align: center;font-weight: 500;" v-else>Pendiente</span>
                                                                </div>
                                                                <v-switch
                                                                v-model="editprospecto.contacto"
                                                                size="24"
                                                                class="ml-2"
                                                                ></v-switch>
                                                            </v-col>                                                                
                                                        </v-toolbar>                                                              
                                                        <v-list-item-subtitle>* Campos obligatorios</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-card-text style="padding-top: 0; padding-bottom: 0;">                                                    
                                                    <v-row align="center">
                                                        <v-col md="6">
                                                            <v-text-field v-model="editcontact.nombre" label="*Nombre contacto"></v-text-field>
                                                        </v-col>
                                                        <v-col sm="6" md="3">
                                                            <v-text-field v-model="editcontact.puesto" label="Puesto"></v-text-field>
                                                        </v-col>
                                                        <v-col sm="6" md="3">
                                                            <v-text-field v-model="editcontact.telefono" label="*Teléfono"></v-text-field>
                                                        </v-col>
                                                        <v-col>
                                                            <v-text-field v-model="editcontact.celular" label="Celular"></v-text-field>                                                            
                                                        </v-col>
                                                        <v-col >
                                                            <v-text-field v-model="editcontact.correo" label="*Correo"></v-text-field>
                                                        </v-col>                                                        
                                                    </v-row>    
                                                    <v-row>
                                                        <v-col style="display: flex;flex-direction: row-reverse;margin-bottom: 10px;">
                                                            <v-btn small color="primary" @click="agregar" dark>Agregar</v-btn>
                                                        </v-col>
                                                    </v-row>                                                 
                                                    <v-row>
                                                        <v-col  style="padding-bottom: 10px;">
                                                            <v-data-table
                                                            :headers="headers"
                                                            :items="contactos"
                                                            sort-by="calories"
                                                            class="elevation-1"
                                                           >
                                                           <template v-slot:[`item.activo`]="{ item }">  
                                                                <div v-if="item.activo">
                                                                    <span class="blue--text">Activo</span>                
                                                                </div>
                                                                <div v-else>
                                                                    <span class="red--text">Inactivo</span>                
                                                                </div>                  
                                                            </template>
                                                            <template v-slot:[`item.opciones`]="{ item }">
                                                                <v-icon
                                                                small
                                                                v-if="item.activo"
                                                                class="mr-2"
                                                                @click="editItemc(item)"
                                                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                color="#3d5170"
                                                                >
                                                                edit
                                                                </v-icon>
                                                                <template v-if="item.activo">
                                                                    <v-icon
                                                                        small
                                                                        class="mr-2"
                                                                        @click="EliminarContacto(item)"
                                                                        style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                        color="#3d5170"
                                                                        >
                                                                        delete
                                                                        </v-icon>                               
                                                                </template>
                                                            </template>     
                                                                <!--<template v-slot:no-data>
                                                                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                                                                </template>-->
                                                            </v-data-table>                                                            
                                                        </v-col>
                                                    </v-row>                                                    
                                                </v-card-text>                                                
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                    <v-divider></v-divider>  
                                    <v-row>
                                        <v-col style="text-align: center;" >
                                            <v-btn style="margin:12px; color:white;" @click="guardar"  color="light-blue darken-4">Guardar</v-btn>
                                             <v-btn style="margin:12px; color:white" color="red darken-4" @click="dialog=false">Cancelar</v-btn>
                                        </v-col>                                        
                                    </v-row>                                              
                                </v-container>
                            </v-form>                           
                        </v-card>
                    </v-dialog>
                </v-row>
                <v-row justify="center">
                    <v-dialog v-model="dialog5" persistent max-width="290">                        
                        <v-card>
                            <v-card-title class="headline"><span style="color:black;width: 100%;">Asignar el Prospecto</span><span style="color: #1976D2;width: 100%;">{{editprospecto.nombre }} &nbsp; &nbsp;  a:</span></v-card-title>
                            <v-card-text>
                                <v-container style="padding:0;">
                                    <v-row style="align-items: center">
                                        <v-col>
                                            <v-select v-model="usuario" :items="usuarios" label="Usuario">
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>                                            
                                            <v-btn color="red darken-1" text @click="dialog5 = false">Cancelar</v-btn>
                                            <v-btn color="primary darken-1" text @click="asignarp(1)">Aceptar</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialog6" persistent max-width="450">                        
                        <v-card>
                            <v-card-title class="headline">
                                <span style="color:black;width: 100%;">Desasignar el Prospecto </span><br>
                                <span style="width: 100%;">{{editprospecto.nombre }} <br></span>
                                <span style="color:black;width: 100%;">al usuario<br></span>
                                <span style="width: 100%;">{{usuario}}</span>
                                <v-textarea
                                v-model="comentario"
                                dense                                
                                label="Comentarios"
                                ></v-textarea>
                            </v-card-title>
                            <v-card-text>
                                <v-container style="padding:0;">                                    
                                    <v-row>
                                        <v-col>                                            
                                            <v-btn color="red darken-1" text @click="dialog6 = false">Cancelar</v-btn>
                                            <v-btn color="green darken-1" text @click="desasginarp()">Aceptar</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                    <v-dialog  v-model="adModal" max-width="350px">
                        <v-card>
                            <v-card-title class="headline" v-if="adAccion==1">¿Activar Prospecto?</v-card-title>
                            <v-card-title class="headline" v-if="adAccion==2">Desactivar Prospecto?</v-card-title>
                            <v-card-text>
                                Estás a punto de 
                                <span v-if="adAccion==1">Activar</span>
                                <span v-if="adAccion==2">Eliminar</span>
                                el Prospecto <br><span style="color: #455A64;font-weight: 500;">{{ adNombre }}</span>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text="text" @click="adModal=false">
                                    Cancelar
                                </v-btn>
                                <v-btn v-if="adAccion==1" color="primary darken1" text="text" @click="activarp">
                                    Aceptar
                                </v-btn>
                                <v-btn v-if="adAccion==2" color="error darken1" text="text" @click="desactivarp">
                                    Eliminar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog  v-model="adModalCont" max-width="350px">
                        <v-card>
                            <v-card-title class="headline" >Eliminar Contacto?</v-card-title>
                            <v-card-text>
                                Estás a punto de Eliminar el Contacto <br><span style="color: #455A64;font-weight: 500;">{{ adNombre }}</span>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text="text" @click="adModal=false">
                                    Cancelar
                                </v-btn>
                                <v-btn color="error darken1" text="text" @click="desactivarc()">
                                    Eliminar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog  v-model="addRazon" max-width="450px">
                        <v-card>
                            <v-toolbar color="primary" dark>
                                Agregar razón social
                            </v-toolbar>
                            <v-card-text><br>
                                <v-row>
                                    <v-col cols="12">
                                        <v-select
                                            v-model="razonsocial"
                                            :items="nrazonsocial"
                                            label="Razon Social">

                                        </v-select>
                                        <!--<v-combobox
                                            v-model="razonsocial"
                                            :items="nrazonsocial"
                                            label="Razon Social"
                                            multiple
                                            chips
                                            ></v-combobox>-->
                                    </v-col>
                                    </v-row>
                            </v-card-text>
                            <v-card-actions class="justify-end">
                                <v-btn color="primary" @click="guardar">Save</v-btn>
                                <v-btn color="error" @click="addRazon = false" >Close</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog  v-model="bajaejecutivo" max-width="650px">
                        <v-card>
                            <v-toolbar color="#f53030" dark>
                                <span style="font-weight: 600;">Baja de Ejecutivo</span>
                            </v-toolbar>
                            <v-card-text><br>
                                <v-row>
                                    <v-col cols="12">
                                        <v-select v-model="bajaejecutivo" v-on:change="CuentasAsignadasEjecutivos()" :items="usuarios" label="Ejecutivos"></v-select>
                                    </v-col>
                                    <v-col>
                                        <v-combobox
                                        v-model="AsignadasSelect"
                                        :items="CuentasAsignadas"
                                        label="Combobox"
                                        multiple
                                        outlined
                                        dense
                                        ></v-combobox>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-select v-model="AsignarEjecutivo" :items="usuarios" label="Asignar a Ejecutivo"></v-select>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions class="justify-end">
                            <v-btn
                            color="primary"
                                @click="reasignar()"
                            >Save</v-btn>
                            <v-btn
                            color="error"
                                @click="bajaejecutivo = false"
                            >Close</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog  v-model="asignarvarios" max-width="650px">
                        <v-card>
                            <v-toolbar color="primary"  dark>
                                <span style="font-weight: 600;">Asignacion de Prospectos</span>
                            </v-toolbar>
                            <v-card-text><br>
                                <v-row>
                                    <v-col>
                                        <v-combobox
                                        v-model="NoasignadasSelect"
                                        :items="noasignados"
                                        label="Combobox"
                                        multiple
                                        outlined
                                        dense
                                        ></v-combobox>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-select dense outlined v-model="AsignarMEjecutivo" :items="usuarios" label="Asignar a Ejecutivo"></v-select>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions class="justify-end">
                            <v-btn
                            color="primary"
                                @click="asignarp(2)"
                            >Save</v-btn>
                            <v-btn
                            color="error"
                                @click="bajaejecutivo = false"
                            >Close</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog  v-model="adModalcontact" max-width="450px">
                        <v-card>
                            <v-card-title class="headline" >Favor de llenar todo los campos *</v-card-title>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text="text" @click="adModalcontact=false">
                                    Aceptar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog 
                            v-model="selectedOpen" max-width="900"
                            scrollable
                        >  
                        <v-card            
                            min-width="350px"
                            class="mx-auto"
                        >
                        <v-toolbar id="create" >
                            <v-row style="width: 100%;align-items: center;">
                            <v-col xs="9" sm="9" md="9" lg="9">
                                <v-row > 
                                <v-col xs="12" sm="12" md="7" lg="7">
                                    <v-toolbar-title text-color="#0277BD" >{{Nameprospecto}}</v-toolbar-title>
                                </v-col>
                                <v-col md="5" lg="5">
                                    <v-toolbar-title text-color="#0277BD" >{{NameActividad}}</v-toolbar-title>
                                </v-col>
                                </v-row>
                            </v-col>
                            <v-col xs="3" sm="3" md="3" lg="3" style="text-align: end;">
                                <v-btn style="color:rgb(17 91 183)" icon @click="selectedOpen = false">                  
                                <v-icon>close</v-icon>
                                </v-btn> 
                            </v-col>
                            </v-row>
                        </v-toolbar>
                        <v-card-text transition="slide-x-transition"><!--Reporte de Actividades-->                
                            <v-timeline align-top :dense=true >
                            <v-timeline-item                                    
                                v-for="(item, i) in items"                    
                                :key="i"
                                color="#0277BD"
                                :icon="item.icono"
                                fill-dot
                            >
                                <v-card                       
                                dark                      
                                color="#0277BD"                      
                                >
                                <v-toolbar v-if="item.completada" color="#0277BD">
                                    <v-card-title class="title">{{item.nombrea}}</v-card-title>
                                    <v-spacer></v-spacer>
                                    <span>{{item.fechaactividad1}}</span>                      
                                    <v-rating  
                                    color="orange"
                                    readonly v-model="item.idexpectativa"></v-rating>
                                </v-toolbar>
                                <v-toolbar v-else color="#ea1404">
                                    <v-card-title style="heig:auto;" class="title">{{item.nombrea}}</v-card-title>
                                    <v-spacer></v-spacer>                                                
                                    <v-col sm="3" md="3" lg="3">
                                    <v-row style="text-align: center;">
                                        <v-col>
                                        <span>{{item.fechaactividad1}}</span>
                                        </v-col>
                                    </v-row>
                                    </v-col>                      
                                    <v-rating  
                                    color="orange"
                                    readonly v-model="item.idexpectativa"></v-rating>
                                </v-toolbar>
                                <v-card-text class="white text--primary">
                                    <v-row>
                                    <v-col>
                                        <p>{{item.reporte}}</p>
                                    </v-col>
                                    </v-row>
                                    <v-row>
                                    <v-col style="display:flex;border-top: 1px solid #CFD8DC;">
                                        <v-list-item-avatar style="margin: 0;color: #546E7A;">
                                        <span class="material-icons">
                                        face
                                        </span>
                                    </v-list-item-avatar>
                                        <v-list-item-content style="color: #546E7A;">
                                            <v-list-item-title>{{item.nombreus}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-col>
                                    </v-row>                                     
                                </v-card-text>                      
                                </v-card>
                            </v-timeline-item>
                            </v-timeline>               
                        </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-row>
                <v-spacer></v-spacer> 
                <v-menu
                    v-if="viewadmin == true" 
                    bottom
                    transition="slide-y-transition"
                    left
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        dark
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon style="color: #1583da;">more_vert</v-icon>
                    </v-btn>
                    </template>
                    <v-list>
                        <v-list-item>
                            <v-list-item-title >
                                <v-btn @click="lipiarnuevo(),dialog = true" color="primary" style="width: 100%;" dark>Nuevo Prospecto</v-btn>
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="$store.state.usuario.rol !== 'Telemarketing' && $store.state.usuario.rol !== 'Comercial'">
                            <v-list-item-title>
                                <v-btn color="primary" style="width: 100%;"  @click="Noasignados">Asignacion multiple</v-btn>
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="$store.state.usuario.rol !== 'Telemarketing' && $store.state.usuario.rol !== 'Comercial'" >
                            <v-list-item-title >
                                <v-btn @click="bajaejecutivo = true" style="width: 100%;" color="#f53030" dark>Baja Ejecutivo</v-btn>
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>     
            </v-toolbar>
        </template>        
        <!--<template v-slot:item.opciones="{ item }">
            <template >
                <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">                    
                    <v-icon
                     v-bind="attrs"
                     v-on="on"
                        small
                        class="mr-2"
                        @click="editItemP(item)"
                        style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                        color="#3d5170"
                        >
                        edit
                    </v-icon>
                </template>
                <span>Edit</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">                    
                        <v-icon
                        v-bind="attrs"
                        v-on="on"
                            small
                            class="mr-2"
                            @click="showEvent(item)"
                            style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                            color="#3d5170"
                            >
                            assignment
                        </v-icon>
                    </template>
                    <span>Report</span>
                </v-tooltip>
                <template v-if="item.activo">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">                    
                            <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            @click="activarDesactivarMostrar(2,item)"     
                            style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                            color="#3d5170"         
                            >
                            block
                            </v-icon> 
                        </template>
                        <span>Desactivar</span>
                    </v-tooltip>
                </template>
                <template v-else>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">                    
                            <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small 
                            @click="activarDesactivarMostrar(1,item)"                   
                            style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                            color="#3d5170"
                            >
                            check
                            </v-icon>
                        </template>
                        <span>Activar</span>
                    </v-tooltip>
                </template> 
            </template>            
        </template> -->
      <!--  <template v-slot:item.asignacion="{ item }" >
            <template v-if="item.activo">
                <template v-if="item.asignacion">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }"  v-if="rolejecutivo === 'Administrador' || rolejecutivo === 'Marketing'">
                            <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="green--text mr-2"
                            @click="asignarpros(1,item)"
                            style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                            >
                                done
                            </v-icon>
                        </template>
                        <template v-else>
                            <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="green--text mr-2"
                            style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                            >
                                done
                            </v-icon>
                        </template>
                        <span>Desasignar</span>
                    </v-tooltip>
                </template>
                <template v-else>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }" v-if="rolejecutivo === 'Administrador' || rolejecutivo === 'Marketing'">
                            <v-icon
                            v-bind="attrs"
                            v-on="on"
                                small
                                class="red--text mr-2"
                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                @click="asignarpros(2,item)"
                                >
                                    clear
                                </v-icon>
                        </template>
                        <template v-slot:activator="{ on, attrs }" v-else>
                            <v-icon
                            v-bind="attrs"
                            v-on="on"
                                small
                                class="red--text mr-2"
                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                @click="asignarpros(2,item)"
                                >
                                    clear
                                </v-icon>
                        </template>
                        <span>Asignar</span>
                    </v-tooltip>
                </template>
            </template>
            <template v-else>
                <span class="red--text">Inactivo</span> 
            </template>
             
        </template>   -->
        <template slot="no-data">
            <v-btn colo="primary" @click="listar">Resetear</v-btn>
        </template> 
        </v-data-table>                        
      </v-flex>
        <v-snackbar
            v-model="snackbar"
            color="cyan darken-2" 
            top
            >
            {{ mensaje }}
            <v-btn
                dark
                text
                @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>        
  </v-layout>  
</template>

<script>

import axios from 'axios'   
export default {
    data () {
      return {
        pagination: {
            sortBy: 'name'
        },
        AsignarMEjecutivo:0,
        NoasignadasSelect:[],
        asignarvarios:false,
        AsignarEjecutivo:0,
        AsignadasSelect:[],
        CuentasAsignadas:[],
        bajaejecutivo:0,
        bajaejecutivo:false,
        razonsocial:'',
        nrazonsocial:[],
        nindustria:[],
        industriaselect:[],
        addRazon:false,
        clienteprospectot:'Cliente',
        clienteprospecto:'Prospecto',
        viewadmin:false,
        viewejecutivo:false,
        mostrartext:false,
        mostrarej:false,
        Nameprospecto:'',
        modelprueba:true,
        items:[],
        selectedOpen:false,
        hreporte:true,
        Buscarp:'',
        searchop:'',
        comentario:'',
        BtnCheck:'',
        BtnCheck2:'',
        modelAutocomplete:null,
        ProspectosComplete:[],
        dialog5:false,
        dialog6:false,  
        dialog:false,   
        search:'',
        nombre:'',
        paises:[],
        idpais:'',
        estados:[],
        idestado:'',
        estatus:[],        
        idestatus:'',
        usuarios:[],
        usuario:'',
        direccion:'',
        producto:'',
        potencialV:'',
        //industria:'',
        observacines:'',
        zona:'',        
        impo:'',
        expo:'',
        fcl:'',
        lcl:'',
        ltl:'',
        ftl:'',
        intermodal:'',
        maritimo:'',
        aereo:'',
        terrestre:'',
        tcuentas:['A','AA','AAA','VIP'],
        idtipocuenta:'',
        dialogprospecto: false,
        dialogContactos:false,
        origenes:[],
        destinos:[],
        headers: [
            { text: 'OPCIONES', value: 'opciones', sortable: false },        
            { text: 'NOMBRE', value: 'nombre' },
            { text: 'PUESTO', value: 'puesto' },
            { text: 'TELÉFONO', value: 'telefono' },
            { text: 'CELULAR', value: 'celular' },
            { text: 'CORREO', value: 'correo', sortable: false },
            { text: 'ESTADO', value: 'activo' },
        ],
        editcontact:{
            idcontacto:'',
            nombre:'',
            puesto:'',
            telefono:'',
            celular:'',
            correo:'',            
        },
        buscar:[
            {text:'Select..',value:-1},
            {text:'Nombre',value:0},
            {text:'Ejecutivo',value:1},
            {text:'Asignadas',value:2},
            {text:'No Asignadas',value:3},
            {text:'No Viables',value:4},
        ],
        buscarpor:-1,
        contactos:[],
        idc:'',
        itemc:'',
        nombrecontacto:'',
        puestocontacto:'',
        telefonocontacto:'',
        celularcontacto:'',
        correocontacto:'',
        bprospecto:'',
        listprospectos:[],
        prospectos:[],
        headersp:[
            {text:'OPCIONES', value: 'opciones', sortable: false },
            {text:'NOMBRE',value:'nombre'},
            {text:'PAÍS',value:'nombrepais',filterable:true},
            {text:'PRODUCTO',value:'producto'},
            {text:'VOLUMEN',value:'potencialV'},
            {text:'OBSERVACIONES',value:'observaciones',sortable: false},
            {text:'ASIGNADO', value: 'asignacion',aling:'center' },
            {text:'EJECUTIVO', value: 'nusuario',aling:'center' },
            {text:'ESTADO', value: 'activo' },
        ],
        editprospecto:{
            contacto:false,
            cliente:false,
            idprospecto:'',
            nombre:'',
            idpais:'',
            idestado:{text:'Select',value:'34'},
            idciudad:'',
            idestatus:'',
            direccion:'',
            producto:'',
            potencialV:'',
            industria:'',
            observaciones:'',
            zona:'',
            tio_cuenta:'',
            impo:'',
            expo:'',
            fcl:'',
            lcl:'',
            ltl:'',
            ftl:'',
            intermodal:'',
            maritimo:'',
            aereo:'',
            terrestre:'',
            asignacion:'',
            activo:'',
        },
        autocomplete:[],
        desserts: [],
        editedIndex: -1,   
        editedIndexp: -1,  
        valiada:'',
        snackbar:false,
        mensaje:'',
        adModal:'',
        adModalCont:false,
        adModalcontact:'',
        adNombre:'',
        adAccion:false,
        searchp:'',
        searcho:'',
        checkall:false,
        checkall2:false,
        check:false,
        check2:false,
        idAsignacion:'',
        prospectossn:[],
        rolejecutivo:'',
        NameActividad:'',
        filters: {
            nombrepais: [],
            nombre: [],
            producto: [],
        },
        selected: [],
        noasignados:[],
        editaorigenes:[],
        editadestinos:[],
        idejecutivo:0,
        ejecutivos:[],
        loadigtable:false,
        }
    },
    computed: {
        formTitle () {//si editedIndex es igual a menos uno estamos agregando un dato nuevo de lo contrario vamos a editar un dato existente
            return this.editedIndexp === -1 ? 'Ingresar Información de Prospecto' : 'Actualizar información de prospecto'
        },
        filteredDesserts() {
            return this.prospectos.filter(d => {
                return Object.keys(this.filters).every(f => {
                return this.filters[f].length < 1 || this.filters[f].includes(d[f])
                })
            })
        },
    },
    created () {
        this.select();
        this.listar();
        this.onPaste();
    },
    methods: {
        onPaste() {
            document.oncontextmenu = new Function("return false;");
            document.oncopy = new Function("return false;");
            document.oncut = new Function("return false;");
            //document.onpaste = new Function("return false;");
        },
        agregarrz(){
            
        },
        listar(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            this.rolejecutivo = this.$store.state.usuario.rol;
            this.loadigtable = true;
            this.prospectos = [];
            if(this.$store.state.usuario.rol == 'Administrador' || this.$store.state.usuario.rol === 'Marketing' || this.$store.state.usuario.rol === 'Telemarketing' || this.$store.state.usuario.rol === 'ComercialAdmin' || this.$store.state.usuario.rol === 'Comercial'){
                let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
                let header={"Authorization" : "Bearer " + this.$store.state.token};
                let configuracion ={headers:header};
                axios.get('api/Prospectos/Listar',configuracion).then(function(response){
                    me.prospectos = response.data;
                    me.viewadmin = true;
                }).catch(function(error){
                    console.log(error);
                });                
            }else{
               // if(this.$store.state.usuario.idusuario == 10076){
                    /*let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
                    let header={"Authorization" : "Bearer " + this.$store.state.token};
                    let configuracion ={headers:header};
                    axios.get('api/Prospectos/Listar',configuracion).then(function(response){
                        me.prospectos=response.data;
                        me.mostrartext = true;
                    }).catch(function(error){
                        console.log(error);
                    });*/
               // }else{
                    let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
                    let header={"Authorization" : "Bearer " + this.$store.state.token};
                    let configuracion ={headers:header};
                    axios.get('api/Prospectos/ListarAsignados/'+ this.$store.state.usuario.idusuario,configuracion).then(function(response){
                        me.prospectos=response.data;
                        me.mostrartext = true;
                    }).catch(function(error){
                        console.log(error);
                    });
             //   }
            }
            this.loadigtable = false;
        },
        CuentasAsignadasEjecutivos(){
            var Arraycuentas = [];
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Prospectos/ListarAsignados/'+ me.bajaejecutivo,configuracion).then(function(response){
                Arraycuentas=response.data;
                Arraycuentas.map(function(x){
                    me.CuentasAsignadas.push({text:x.nombre,value:x.idprospecto})
                })
            }).catch(function(error){
                console.log(error);
            });

        },
        autocompletar(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var prospectosArray = [];
            axios.get('api/Prospectos/BuscarProspecto/'+me.editprospecto.nombre,configuracion)
            .then(function(response){            
            prospectosArray = response.data;
            prospectosArray.map(function(x){
                me.ProspectosComplete,push({text:x.nombre,value:x.idprospecto})
            });
            }).catch(function(error){
                console.log(error);            
            });
        },
        select(){//mandamos llamar el controlador Puertos y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
                let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
                let header={"Authorization" : "Bearer " + this.$store.state.token};
                let configuracion ={headers:header};
                var paisesArray=[];
                var estadosArray=[];
                var estatusArray=[];
                var usuariosArray=[];
                var industriaArray=[];
                var prospectoArray=[];

                axios.get('api/Datos/SelectCliente',configuracion).then(function(response){            
                    prospectoArray=response.data;
                    prospectoArray.map(function(x){
                        me.nrazonsocial.push({text:x.nombre,value:x.iddatos});
                    });            
                }).catch(function(error){
                    console.log(error);
                });
                axios.get('api/Paises/Select',configuracion).then(function(response){                
                    paisesArray=response.data;
                    paisesArray.map(function(x){
                        me.paises.push({text:x.nombre,value:x.idpais});
                    });            
                }).catch(function(error){
                    console.log(error);
                });  
                axios.get('api/Industrias/Select',configuracion).then(function(response){                
                industriaArray=response.data;
                industriaArray.map(function(x){
                    me.nindustria.push({text:x.nombre,value:x.idindustria});
                });
                }).catch(function(error){
                    console.log(error);
                });            
                axios.get('api/Estados/Select',configuracion).then(function(response){                
                estadosArray=response.data;
                estadosArray.map(function(x){
                    me.estados.push({text:'Select',value:'34'});
                    me.estados.push({text:x.nombre,value:x.idestado});
                    me.editprospecto.idestado = 'Select';
                });            
                }).catch(function(error){
                    console.log(error);
                });
                axios.get('api/Estatus/Select',configuracion).then(function(response){                
                estatusArray=response.data;
                estatusArray.map(function(x){
                    me.estatus.push({text:x.nombre,value:x.idestatus});
                });            
                }).catch(function(error){
                    console.log(error);
                });
            /*    if(this.$store.state.usuario.rol == 'Telemarketing'){
                    axios.get('api/Usuarios/SelectReportelemarketing',configuracion).then(function(response){
                        usuariosArray=response.data;
                        usuariosArray.map(function(x){
                            me.usuarios.push({text:x.nombre,value:x.idusuario});
                        });            
                    }).catch(function(error){
                        console.log(error);
                    }); 
                }else{*/
                    axios.get('api/Usuarios/SelectReport',configuracion).then(function(response){
                        usuariosArray=response.data;
                        usuariosArray.map(function(x){
                            me.usuarios.push({text:x.nombre,value:x.idusuario});
                        });            
                    }).catch(function(error){
                        console.log(error);
                    }); 
                //}
                               
        },
        lipiarnuevo(){
            this.editprospecto.idprospecto = '';
            this.editprospecto.nombre = '';
            this.editprospecto.idpais = '';
            this.editprospecto.idestado = '';
            this.editprospecto.idciudad = '';
            this.editprospecto.idestatus = '';
            this.editprospecto.direccion = '';
            this.editprospecto.producto = '';
            this.editprospecto.potencialV = '';
            this.editprospecto.industria = '';
            this.editprospecto.observaciones = '';
            this.editprospecto.zona = '';
            this.editprospecto.tio_cuenta = '';
            this.editprospecto.impo = '';
            this.editprospecto.expo = '';
            this.editprospecto.fcl = '';
            this.editprospecto.lcl = '';
            this.editprospecto.ltl = '';
            this.editprospecto.ftl = '';
            this.editprospecto.intermodal = '';
            this.editprospecto.maritimo = '';
            this.editprospecto.aereo = '';
            this.editprospecto.terrestre = '';
            this.editprospecto.activo = '';
            this.editcontact.nombre = "";
            this.editcontact.puesto = "";
            this.editcontact.telefono= "";
            this.editcontact.celular = "";
            this.editcontact.correo = "";
            this.comentario = "";
            this.contactos=[];
            this.editprospecto = [];
            this.prospectos = [];
            this.editedIndexp = -1;
            this.origenes = '';
            this.destinos = '';
        },
        limpiar (){
            this.editcontact.nombre = "";
            this.editcontact.puesto = "";
            this.editcontact.telefono= "";
            this.editcontact.celular = "";
            this.editcontact.correo = "";        
            this.editedIndex = -1;
        },
        editItemc (item) {
            this.editedIndex = this.contactos.indexOf(item)
            this.editcontact = Object.assign({}, item)
        },
       async editItemP (item) {
            this.editedIndexp = this.prospectos.indexOf(item)            
            this.editprospecto = Object.assign({}, item)                    
            await this.listarContacto(this.editprospecto.idprospecto);
            await this.listarIndustria(this.editprospecto.idprospecto);
            await this.listarorigendestino(this.editprospecto.idprospecto);
            this.dialog = true
        },
        listarorigendestino(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header}; 

            var origen = [];
            me.origenes = [];
            me.destinos = [];
            me.editaorigenes = [];
            me.editadestinos = [];
            axios.get('api/OrigenDestinos/BuscarOrigenDestino/'+id,configuracion).then(function(response){
                    origen=response.data;
                    for(var i = 0; i < origen.length; i++ ){
                        if(origen[i].descripcion == 'O'){
                            me.origenes.push({text:origen[i].text,value:origen[i].value})
                            me.editaorigenes.push({text:origen[i].text,value:origen[i].value})
                        }else{
                            me.destinos.push({text:origen[i].text,value:origen[i].value})
                            me.editadestinos.push({text:origen[i].text,value:origen[i].value})
                        }   
                    }
                }).catch(function(error){
                    console.log(error);
            });
        },
        asignarpros(idc,item){
            if(idc == 2){
                
                this.dialog5 = true;

            }else{
                this.dialog6 = true;
            }
            this.editprospecto = Object.assign({}, item);            
            this.usuario='';
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var ArrayUsuario = [];
            axios.get('api/Asignaciones/Select/' + me.editprospecto.idprospecto,configuracion).then(function(response){                
            ArrayUsuario=response.data;
            ArrayUsuario.map(function(x){
                me.usuario = x.nombreu;
                me.idAsignacion = x.idasignacion;
            });
            }).catch(function(error){
                console.log(error);
            });
        },
        listarIndustria(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Industria/listar/'+id,configuracion).then(function(response){            
                me.industria=response.data;
            }).catch(function(error){
                console.log(error);
            });
        },
        listarContacto(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var consulta = '';
            if(this.$store.state.usuario.rol == 'Administrador' || this.$store.state.usuario.rol === 'Marketing'){
                consulta = 'api/Contactos/ListarContactoA/';
            }else{
                consulta = 'api/Contactos/ListarContacto/';
            }
            axios.get(consulta+id,configuracion).then(function(response){            
                me.contactos=response.data;
            }).catch(function(error){
                console.log(error);
            });
        },
        agregar(){         
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;

            if(model.editcontact.nombre === '' || model.editcontact.correo === ''){        
                model.adModalcontact = true;
            }else
            {
                 if (model.editedIndexp > -1) {
                     if (model.editedIndex > -1) {
                        Object.assign(model.contactos[model.editedIndex], model.editcontact)    
                        axios.put('api/Contactos/Actualizar',{
                            'idcontacto': model.editcontact.idcontacto,                            
                            'nombre': model.editcontact.nombre,
                            'puesto' : model.editcontact.puesto,                    
                            'telefono' : model.editcontact.telefono,
                            'celular' : model.editcontact.celular,
                            'correo' : model.editcontact.correo,
                            'idpropietario' : model.editprospecto.idprospecto
                        },configuracion).then(function(response){                                                                       
                            model.editedIndex = -1;                            
                            model.limpiar();
                            model.snackbar = true;
                            model.mensaje = 'Contacto Actualizado'                                                      
                        }).catch(function(error){
                            console.log(error);
                        });  

                    } else {  
                        model.contactos.push({
                            nombre:model.editcontact.nombre,
                            puesto:model.editcontact.puesto,
                            telefono:model.editcontact.telefono,
                            celular:model.editcontact.celular,
                            correo:model.editcontact.correo,
                            activo:1
                        })                      
                         axios.post('api/Contactos/Crear',{
                            'nombre': model.editcontact.nombre,
                            'puesto' : model.editcontact.puesto,                    
                            'telefono' : model.editcontact.telefono,
                            'celular' : model.editcontact.celular,
                            'correo' : model.editcontact.correo,
                            'propietario' : 'pros',
                            'idpropietario' : model.editprospecto.idprospecto
                        },configuracion).then(function(response){                                  
                            model.limpiar();
                            model.snackbar = true;
                            model.mensaje = 'Contacto guardado  ' 
                        }).catch(function(error){                                                
                            console.log(error); 
                        });                                      
                    }                    
                }
                else{
                    if (model.editedIndex > -1) {
                        Object.assign(model.contactos[model.editedIndex], model.editcontact)
                        model.editedIndex = -1;
                    } else {                        
                        model.contactos.push({
                            nombre:model.editcontact.nombre,
                            puesto:model.editcontact.puesto,
                            telefono:model.editcontact.telefono,
                            celular:model.editcontact.celular,
                            correo:model.editcontact.correo,
                            activo:1
                        })
                        model.limpiar();  
                    }
                }
            }
        },
        deleteItem (item) {
            
            const index = this.contactos.indexOf(item)
            confirm('Esta seguro que desea eliminar este contacto?') && this.contactos.splice(index, 1)
        },
        removeorigenes (item) {
            this.origenes.splice(this.origenes.indexOf(item),1)
            this.origenes=[...this.origenes]
        },
        removedestinos (item) {
            this.destinos.splice(this.destinos.indexOf(item),1)
            this.destinos = [...this.destinos]
        },   
        guardar() {
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;  

            if(model.editprospecto.idestado == undefined || model.editprospecto.idestado == false){
                model.editprospecto.idestado = '34';
            }

            if (model.editedIndexp > -1) {//codigo para editar

                    for(var i=0; i < model.origenes.length;i++){
                        var existe = false;
                        for(var j=0; j < model.editaorigenes.length;j++){
                            if(model.origenes[i].value == model.editaorigenes[j].value){

                            }
                        }
                    }
                axios.put('api/Prospectos/Actualizar',{
                    'idprospecto': model.editprospecto.idprospecto,
                    'nombre' : model.editprospecto.nombre,                    
                    'idpais' : model.editprospecto.idpais,
                    'idestado' : model.editprospecto.idestado,             
                    'idestatus' : model.editprospecto.idestatus,
                    'direccion' : model.editprospecto.direccion,
                    'producto' : model.editprospecto.producto,
                    'potencialV' : model.editprospecto.potencialV,
                    'industria' : model.editprospecto.industria,
                    'observaciones' : model.editprospecto.observaciones,
                    'zona' : model.editprospecto.zona,
                    'tio_cuenta' : model.editprospecto.tio_cuenta,
                    'impo' : model.editprospecto.impo,
                    'expo' : model.editprospecto.expo,
                    'fcl' : model.editprospecto.fcl,
                    'lcl' : model.editprospecto.lcl,
                    'ltl' : model.editprospecto.ltl,
                    'ftl': model.editprospecto.ftl,
                    'intermodal' : model.editprospecto.intermodal,
                    'maritimo' : model.editprospecto.maritimo,
                    'aereo' : model.editprospecto.aereo,
                    'terrestre' : model.editprospecto.terrestre,
                    'cliente':model.editprospecto.cliente,
                    'origenes' : model.origenes,
                    'destinos' : model.destinos,
                    //'idcliente':model.razonsocial,
                    'rol':this.$store.state.usuario.rol,
                    'idusuario':this.$store.state.usuario.idusuario
                },configuracion).then(function(response){                      
                    model.dialog= false,
                    model.snackbar = true
                    model.mensaje = 'Prospecto Actualizado correctamente'
                    model.addRazon = false;
                    model.lipiarnuevo();
                    model.listar();
                }).catch(function(error){
                    console.log(error);
                });  
            } else {//codigo para guardar
                axios.post('api/Prospectos/Crear',{
                    'nombre' : model.editprospecto.nombre,
                    'idpais' : model.editprospecto.idpais,
                    'idestado' : model.editprospecto.idestado,
                    'idestatus' : model.editprospecto.idestatus,
                    'direccion' : model.editprospecto.direccion,
                    'producto' : model.editprospecto.producto,
                    'potencialV' : model.editprospecto.potencialV,
                    'industria' : model.editprospecto.industria,
                    'observaciones' : model.editprospecto.observaciones,
                    'zona' : model.editprospecto.zona,
                    'tio_cuenta' : model.editprospecto.tio_cuenta,
                    'impo' : model.editprospecto.impo,
                    'expo' : model.editprospecto.expo,
                    'fcl' : model.editprospecto.fcl,
                    'lcl' : model.editprospecto.lcl,
                    'ltl' : model.editprospecto.ltl,        
                    'ftl': model.editprospecto.ftl,
                    'intermodal' : model.editprospecto.intermodal,
                    'maritimo' : model.editprospecto.maritimo,
                    'aereo' : model.editprospecto.aereo,
                    'terrestre' : model.editprospecto.terrestre,
                    'cliente':model.editprospecto.cliente,
                    'contactop':model.editprospecto.contacto,
                    'contactos':model.contactos,
                    'origenes' : model.origenes,
                    'destinos' : model.destinos,
                    'rol':this.$store.state.usuario.rol,
                    'idusuario':this.$store.state.usuario.idusuario
                },configuracion).then(function(response){
                    model.dialog= false,
                    model.snackbar = true                      
                    model.mensaje = 'Prospecto guardado correctamente'
                    model.addRazon = false;
                    /*if(this.$store.state.usuario.rol === 'Comercial'){
                        this.asignarp(n);
                        this.usuario = this.$store.state.usuario.idusuario;
                    }*/
                    model.lipiarnuevo();
                    model.listar();
                }).catch(function(error){                                                
                    console.log(error); 
                });
            }            
        },                
        activar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.put('api/Contactos/Activar/'+this.adId,{},configuracion).then(function(response){
                Object.assign(model.contactos[model.editedIndex], model.editcontact)
            }).catch(function(error){
                console.log(error);
            }); 
        },        
        desactivar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.put('api/Contactos/Desactivar/'+this.adId,{},configuracion).then(function(response){                
                Object.assign(model.contactos[model.editedIndex], model.editcontact)
            }).catch(function(error){
                console.log(error);
            });
        },
        activarp(){
            let model=this;
            let header={"Authorization" : "Bearer " + model.$store.state.token};
            let configuracion ={headers:header};
            axios.put('api/Prospectos/Activar/'+ model.adId,{},configuracion).then(function(response){
                model.limpiar();
                model.listar();
                model.adModal = false
                model.mensaje = 'Prospecto Desactivado'
            }).catch(function(error){
                model.mensaje = error
            }); 
        },        
        desactivarp(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;  
            model.snackbar = true 

            axios.put('api/Prospectos/Desactivar/'+ model.adId,{},configuracion).then(function(response){                
                model.limpiar();
                model.listar();
                model.adModal = false
                model.mensaje = 'Prospecto Desactivado' 
            }).catch(function(error){
                model.mensaje = error
            });
        },         
        cerrar(){
            dialog = true;
        },
        asignarp(n){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;  
            
            var f = new Date();
            var hoy =  f.getDate() + "-" + (f.getMonth() +1) + "-" + f.getFullYear();
            var fecha = new Date(hoy);
            if(n == 1){
                axios.post('api/Asignaciones/Crear',{
                    'idprospecto' : model.editprospecto.idprospecto,
                    'nombrec':model.editprospecto.nombre,
                    'idusuario' : model.usuario,
                    'fechasAsignacion' : f,
                    'multiple':false
                },configuracion).then(function(response){
                    model.lipiarnuevo();
                    model.listar();
                    model.dialog5 = false;
                    model.snackbar = true;
                    model.mensaje = 'Asignacion correctamente';
                    model.NoasignadasSelect = [];
                    model.AsignarMEjecutivo = 0;
                    model.asignarvarios = false;
                }).catch(function(error){
                    model.snackbar = true
                    model.mensaje = error 
                });
            }else{
                if(model.AsignarMEjecutivo != 0){
                    axios.post('api/Asignaciones/Crear',{
                        'prospectos':model.NoasignadasSelect,
                        'idusuario' : model.AsignarMEjecutivo,
                        'fechasAsignacion' : f,
                        'multiple':true
                    },configuracion).then(function(response){
                        model.lipiarnuevo();
                        model.listar();
                        model.dialog5 = false;
                        model.snackbar = true;
                        model.mensaje = 'Asignacion correctamente';
                        model.NoasignadasSelect = [];
                        model.AsignarMEjecutivo = 0;
                        model.asignarvarios = false;
                    }).catch(function(error){
                        model.snackbar = true;
                        model.mensaje = error ;
                    });
                }else{
                    window.alert('Seleccionar ejecutivo');
                }
            }
        },
        reasignar(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;  
            
            var f = new Date();
            var hoy =  f.getDate() + "-" + (f.getMonth() +1) + "-" + f.getFullYear();
            var fecha = new Date(hoy);


            if(model.AsignarEjecutivo != 0){
                    axios.post('api/Asignaciones/Reasignar',{
                        'prospectos':model.AsignadasSelect,
                        'idusuario' : model.AsignarEjecutivo,
                        'fechasAsignacion' : f,
                        'multiple':true
                    },configuracion).then(function(response){
                        model.lipiarnuevo();
                        model.listar();
                        model.dialog5 = false;
                        model.snackbar = true;
                        model.mensaje = 'Asignacion correctamente';
                        model.AsignadasSelect = [];
                        model.AsignarEjecutivo = 0;
                        model.bajaejecutivo = 0;
                        model.bajaejecutivo = false;
                    }).catch(function(error){
                        model.snackbar = true;
                        model.mensaje = error ;
                    });
                }else{
                    window.alert('Seleccionar ejecutivo');
                }
        },
        desasginarp(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;  
            model.snackbar = true;
            axios.put('api/Prospectos/Desasignar',{                                         
                'idprospecto':model.editprospecto.idprospecto,
                'idasignacion':model.idAsignacion,
                'comentarios':model.comentario
            },configuracion).then(function(response){
                model.lipiarnuevo();
                model.listar();
                model.dialog6 = false
                model.mensaje = 'Prospeto desasignado'
            }).catch(function(error){
                console.log(error);
            }); 
        },
        desactivarc(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;  
            axios.put('api/Contactos/Desactivar/'+ model.adId,{},configuracion).then(function(response){
                model.adModalCont = false;
                model.snackbar = true;
                model.mensaje = 'Contacto Eliminado';
                model.listarContacto(model.editprospecto.idprospecto)
            }).catch(function(error){
                model.mensaje = error
            });
        },
        EliminarContacto(item){
            this.adNombre = item.nombre;
            this.adModalCont = true;
            this.adId=item.idcontacto;
        },
        activarDesactivarMostrar(accion,item){
            if(accion == 1){
                this.adAccion=1;           
            }else{
                this.adAccion=2;
            }

            this.adModal=true;
            this.adNombre=item.nombre;                  
            this.adId=item.idprospecto;
        },
        allcheck(){            
            if(this.check == true){
               this.checkall = false;
               this.check = false;
            }
            if(this.checkall == true){
                this.editprospecto.impo =  true; 
                this.editprospecto.expo =  true;
                this.editprospecto.fcl =  true;
                this.editprospecto.lcl = true;
                this.editprospecto.ftl = true;
                this.editprospecto.ltl = true;
                this.editprospecto.intermodal= true;
                this.check= true;                
            }else{
                this.editprospecto.impo =  false; 
                this.editprospecto.expo =  false;
                this.editprospecto.fcl =  false;
                this.editprospecto.lcl = false;
                this.editprospecto.ftl = false;
                this.editprospecto.ltl = false;
                this.editprospecto.intermodal= false;
            }
            

        },
        allcheck2(){
            if(this.check2 == true){
               this.checkall2 = false;
               this.check2 = false;
            }
            if(this.checkall2 == true){
                this.editprospecto.maritimo = true;
                this.editprospecto.aereo = true;
                this.editprospecto.terrestre = true;
                this.check2= true;                
            }else{
                this.editprospecto.maritimo = false;
                this.editprospecto.aereo = false;
                this.editprospecto.terrestre = false;
            }
        },
        activarestado(){
            if(this.editprospecto.idpais == 1){
                this.editprospecto.idestado = false;
            }else{
                this.editprospecto.idestado = false;
            }
        },
        showEvent(event){
        this.selectedOpen = true;
        this.NameActividad = 'Historial de Reportes';
        this.Nameprospecto = '';
        var actividades = []; 
        this.items = [];
        
        let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
        let header={"Authorization" : "Bearer " + this.$store.state.token};
        let configuracion ={headers:header};
            axios.get('api/Actividades/ListarActividad/' + event.idprospecto,configuracion).then(function(response){            
              actividades=response.data;
              if(actividades.length > 0){
                  actividades.map(function(x){
                    me.items.push({
                        idactividad:x.idactividad,
                        idprospecto:x.idprospecto,
                        nombrea:x.nombrea,
                        icono:x.icono,
                        idexpectativa:x.idexpectativa,
                        expectativa:x.expectativa,
                        idusuario:x.idusuario,
                        nombreus:x.nombreus,
                        reporte:x.reporte,
                        fechaactividad1:x.fechaactividad1,
                        reagendaractividad:x.reagendaractividad,
                        completada:x.completada,
                        tipoactividad:x.idtipo_actividad
                        });
                        me.Nameprospecto= event.nombre;
                    })
              }else{
                  me.NameActividad = 'No cuenta con reporte';
              }
              
          }).catch(function(error){
              console.log(error);
          });
        },
        Mostrarusuarios(){            
            this.mostrarej = false;
            this.mostrartext = false;
            if(this.buscarpor == 1){
                this.mostrarej = true;
            }
            if(this.buscarpor == 0){
                this.listar();
                this.mostrartext = true;
            }
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};

            if(me.buscarpor == 2){
             me.prospectos = [];
                axios.get('api/Prospectos/ListarNoasignadas/'+ true,configuracion).then(function(response){
                    me.prospectos=response.data;
                }).catch(function(error){
                    console.log(error);
                });   
            }
            if(me.buscarpor == 3){
             me.prospectos = [];
                axios.get('api/Prospectos/ListarNoasignadas/'+ false,configuracion).then(function(response){
                    me.prospectos=response.data;
                }).catch(function(error){
                    console.log(error);
                });   
            }
        },
        Noasignados(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.noasignados = [];
            var noasinados = [];
            me.NoasignadasSelect = [];
            me.AsignarMEjecutivo = 0;
            axios.get('api/Prospectos/SelectNoasignados',configuracion).then(function(response){
                noasinados = response.data;
                noasinados.map(function(x){
                    me.noasignados.push({text:x.nombre,value:x.idprospecto})
                })
                me.asignarvarios = true;
            }).catch(function(error){
                console.log(error);
            });  
        },
        buscarporI(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            if(this.buscarpor == 1){
                me.prospectos = [];
                axios.get('api/Prospectos/ListarAsignados/'+ this.ejecutivo,configuracion).then(function(response){
                    me.prospectos=response.data;
                }).catch(function(error){
                    console.log(error);
                });
            }
        },
        /********************************************************************/
        toggleAll () {
            if (this.selected.length) this.selected = []
            else this.selected = this.prospectos.slice()
        },
        changeSort (column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        },
        columnValueList(val) {
            return this.prospectos.map(d => d[val])
        }
    },
  }
</script>